import { Component, OnInit, ViewChild } from '@angular/core';
import { ClassService, ConfigService } from './../../../../../_services';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigsCategoryModalComponent } from '../configs-modals/category-modal/configs-category-modal.component';
import { ConfigsCategoryCreateModalComponent } from '../configs-modals/category-create-modal/configs-category-create-modal.component';
import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';
import { Config } from '../../../../../_models/config';


@Component({
    selector: 'app-configs-categories',
    templateUrl: './configs-categories.component.html',
    styles: ['[class^="la-"], [class*=" la-"] { padding:5px; }',
        'a { text-decoration: none; }'
    ]
})
export class ConfigsCategoriesComponent implements OnInit {
    @ViewChild('modalComponent') modalComponent: ConfigsCategoryModalComponent;
    @ViewChild('createModalComponent') createModalComponent: ConfigsCategoryCreateModalComponent;
    @ViewChild('deleteQuestionSwal') private deleteQuestionSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    public categories: any[];
    public category_id: number;
    public model = new Config(null, null, null, null, null, null, null);
    public currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    selectedCategory: any;

    constructor(private _configService: ConfigService,
        private _modalService: NgbModal) { }

    ngOnInit() {
        this.getAllCategories();
    }
    getIdCategory(id) {
        this.category_id = id;
    }

    getTypeName(type) {
        let value = '';
        switch (type) {
            case "income":
                value = 'Ingresos';
                break;
            case "expense":
                value = 'Egresos';
                break;
            default:
                value = 'N.D.';
                break;
        }
        return value;
    }

    getAllCategories() {
        this._configService.getAllCategories().subscribe(data => {
            this.categories = data.data;
        }, err => {
            console.log(err);
        }, () => {

        });
    }

    deleteCategory(id) {
        this._configService.deleteCategory(id).subscribe(response => {
            if (response['status'] == 'ok') {
                this.successSwal.text = response['message'];
                this.successSwal.show();
            } else {
                this.errorSwal.text = response['message'];
                this.errorSwal.show();
            }

        }, error => {
            this.errorSwal.text = error;
            this.errorSwal.show();
        });
    }

    reload() {
        window.location.reload();
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-categories/configs-categories.component.ts